<template>
    <nav class="bg-white border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex items-center h-16 space-x-4">
                <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
                    <component
                        :is="breadcrumb.current ? 'span' : 'a'"
                        :href="breadcrumb.href"
                        :class="[
              breadcrumb.current
                ? 'text-gray-900 font-medium'
                : 'text-gray-400 hover:text-gray-600'
            ]"
                    >
                        {{ breadcrumb.label }}
                    </component>

                    <span v-if="index < breadcrumbs.length - 1" class="text-gray-400">•</span>
                </template>
            </div>
        </div>
    </nav>
</template>

<script setup>
defineProps({
    breadcrumbs: {
        type: Array,
        required: true
    }
})
</script>
